import controller from './card-grid.controller';
import template from './card-grid.html';

export default {
	template,
	bindings: {
		component: '<?',
		disabled:  '<?ngDisabled',
		items:     '<?ngModel',
		options:   '<?',
	},
	controller,
	require:  {
		builder:     '^^?formBuilder',
		kformCtrl:   '^^?kform',
		ngModelCtrl: 'ngModel',
	},
};
